import mutations from './mutations'
import state from './state'
import gettersUniqueCode from '@/store/modules/UniqueKey/getters'
import apiCashMov from '@/services/API/CashMov'

const setTypeMovement = function({ commit }, typeMovementPayLoad) {
    commit('SET_TYPE_MOVEMENT', typeMovementPayLoad)
}

const setMovement = function({ commit }, movementPayLoad) {
    commit('SET_MOVEMENT', movementPayLoad)
}

const setDate = function({ commit }, datePayLoad) {
    commit('SET_DATE', datePayLoad)
}

const setCashAmount = function({ commit }, cashAmountPayLoad) {
    if (parseInt(cashAmountPayLoad) % 10 === 0) {
        commit('SET_CASH_AMOUNT', cashAmountPayLoad)
    } else {
        commit('SET_CASH_AMOUNT', null)
    }
}

const setMovementType = function({ commit }, typeMovementPayload) {
    commit('SET_MOVEMENT_TYPE', typeMovementPayload)
}

const setComment = function({ commit }, commentPayLoad) {
    commit('SET_COMMENT', commentPayLoad)
}

const loadMovementReasons = async function({ commit }) {
    let ingressTypes = await apiCashMov.fetchIngressType()
    commit('SET_INGRESS_TYPES', ingressTypes.data)

    let egressTypes = await apiCashMov.fetchEgressType()
    commit('SET_EGRESS_TYPES', egressTypes.data)
}

const setUniqueKey = function({ commit }, uniqueKeyPayLoad) {
    commit('SET_UNIQUE_KEY', uniqueKeyPayLoad)
}

const resetState = function({ commit }) {
    commit('RESET_STATE')
}

const saveCashMov = async function({ state, rootState }) {
    let user = rootState.AuthModule.user
    let cashDeskID = rootState.AuthModule.cash_desk_id
    if (state.movement === 'apertura') {
        let response = await apiCashMov.posDailyCash(
            cashDeskID,
            user.id, //user ID
            parseInt(state.cashAmount),
            state.comment
        )
        return response
    } else if (state.movement === 'ingreso') {
        let response = await apiCashMov.posCashMovement(
            cashDeskID,
            null,
            state.movementType,
            user.id,
            parseInt(state.cashAmount),
            state.comment
        )
        return response
    } else {
        let response = await apiCashMov.posCashMovement(
            cashDeskID,
            state.movementType,
            null,
            user.id,
            parseInt(state.cashAmount),
            state.comment
        )
        return response
    }
}

const printReceip = async function(
    { getters, rootState, rootGetters },
    { idMovCaja, supervisor = null }
) {
    const fullName = e => `${e.names} ${e.last_name1}`
    let user = rootState.AuthModule.user
    let win = window.open('../movement.html')
    win.window.title = state.typeMovement.toUpperCase()
    win.window.subtitle = `DOCN°${DOCNum(idMovCaja)}`
    win.window.date = getDate()
    win.window.time = getTime()
    win.window.amount = parseInt(state.cashAmount)
    win.window.movementTypeName = getters.movementTypeName
    win.window.cashierName = fullName(user.hr_employee)
    win.window.cashierID = user.id
    win.window.comment = state.comment
    win.window.preventPrint = rootState.SessionModule.preventPrint
    win.window.closeTimeout = process.env.VUE_APP_PRINTER_TIMEOUT

    //Info Sucursal
    win.window.officeID = rootGetters['AuthModule/branchOfficeID']
    win.window.officeName = rootGetters['AuthModule/branchOfficeName']
    win.window.cashDesk = rootGetters['AuthModule/cashDeskID']

    //TODO: If needed supervisor name and id on tickets
    if (supervisor) {
        win.window.supervisorName = supervisor.name // después recibir de algún otro store
        win.window.supervisorID = supervisor.id // después recibir de algún otro store
    }
    return true
}

const printReceipRaw = async function(
    { getters, rootState, rootGetters },
    { idMovCaja, amount, comment, supervisor = null }
) {
    const fullName = e => `${e.names} ${e.last_name1}`
    let user = rootState.AuthModule.user
    let win = window.open('../movement.html')
    win.window.title = 'EGRESO DE CAJA' // state.typeMovement.toUpperCase()
    win.window.subtitle = `DOCN°${DOCNum(idMovCaja)}`
    win.window.date = getDate()
    win.window.time = getTime()
    win.window.amount = parseInt(amount)
    win.window.movementTypeName = 'EGRESO DE CAJA' //getters.movementTypeName
    win.window.cashierName = fullName(user.hr_employee)
    win.window.cashierID = user.id
    win.window.comment = comment
    win.window.preventPrint = rootState.SessionModule.preventPrint
    win.window.closeTimeout = process.env.VUE_APP_PRINTER_TIMEOUT

    //Info Sucursal
    win.window.officeID = rootGetters['AuthModule/branchOfficeID']
    win.window.officeName = rootGetters['AuthModule/branchOfficeName']
    win.window.cashDesk = rootGetters['AuthModule/cashDeskID']

    //TODO: If needed supervisor name and id on tickets
    if (supervisor) {
        win.window.supervisorName = supervisor.name // después recibir de algún otro store
        win.window.supervisorID = supervisor.id // después recibir de algún otro store
    }
    return true
}

// TODO: Mover esto a un mixin (revisar si quizá ya lo hice)
const DOCNum = function(idMovCaja) {
    idMovCaja = idMovCaja.toString()
    // console.log('largo: ', idMovCaja.length)
    let zerosString = ''
    for (let i = 0; i < 12 - idMovCaja.length; i++) {
        zerosString = zerosString.concat('0')
    }
    return zerosString.concat(idMovCaja)
}

// TODO: Mover esto a un mixin (creo que ya lo moví a un mixin pero aun no lo llamo desde ahi)
const getDate = function() {
    let date = new Date()

    let year = date.getFullYear()

    let month = date.getMonth() + 1
    if (month < 10) {
        month = `0${month}`
    } else {
        month = `${month}`
    }

    let day = date.getDate()
    if (day < 10) {
        day = `0${day}`
    } else {
        day = `${day}`
    }

    return `${day}/${month}/${year}`
}

// TODO: Mover esto a un mixin (creo que ya lo moví a un mixin pero aun no lo llamo desde ahi)
const getTime = function() {
    let date = new Date()

    let hours = date.getHours()
    if (hours < 10) {
        hours = `0${hours}`
    } else {
        hours = `${hours}`
    }

    let minutes = date.getMinutes()
    if (minutes < 10) {
        minutes = `0${minutes}`
    } else {
        minutes = `${minutes}`
    }

    let seconds = date.getSeconds()
    if (seconds < 10) {
        seconds = `0${seconds}`
    } else {
        seconds = `${seconds}`
    }
    return `${hours}:${minutes}:${seconds}`
}

export default {
    setTypeMovement,
    setMovement,
    setDate,
    setCashAmount,
    setComment,
    setMovementType,
    setUniqueKey,
    resetState,
    loadMovementReasons,
    saveCashMov,
    printReceip,
    printReceipRaw,
}
